import Mock from 'mockjs';

// 定义 Mock 数据
const mockData = Mock.mock({
  'data|10': [
    {
      // 生成10条数据
      'key|+1': 1, // 自增
      publishTime: '@datetime', // 随机生成日期时间
      thumbnail: '@image("100x100")', // 随机生成100x100的图片
      play: '播放图标', // 示例播放图标
      title: '@ctitle(5, 10)', // 随机生成中文标题，长度在5到10之间
      summary: '@csentence(10, 20)', // 随机生成中文句子，长度在10到20之间
      'views|100-1000': 100, // 随机生成观看数，范围从100到1000
      'comments|0-100': 0, // 随机生成评论数，范围从0到100
      'likes|0-500': 0, // 随机生成点赞数，范围从0到500
      'shares|0-50': 0, // 随机生成分享数，范围从0到50
      'status|1': ['正常', '下架'], // 随机生成状态
      'audit|1': ['审核中', '通过', '拒绝'], // 随机生成审核状态
    },
  ],
});

Mock.mock('/api/video', 'get', () => {
  return {
    code: 0,
    data: mockData.data,
    message: 'success',
  };
});

Mock.mock('barcode/account', 'get', ({}) => {
  return {
    code: 0,
    message: 'success',
    data: {
      account: {
        username: 'iczer',
        age: 18,
        gender: 0,
        avatar: 'http://portrait.gitee.com/uploads/avatars/user/691/2073535_iczer_1578965604.png!avatar30',
      },
      role: 'admin',
      permissions: ['edit', 'delete', 'add'],
    },
  };
});
